module.exports = __webpack_public_path__ + "img/bin.55489206.svg";